import { Slider as SliderAntd } from 'antd';
import './Slider.scss';

const Slider = ({ ...props }) => {
  return <SliderAntd defaultValue={30} {...props} />;
};

export default Slider;
